module.exports = __webpack_public_path__ + "img/kasir-active.44b41312.svg";